import React from 'react';
import { TabElementLabel, TabHeader, TabRow } from '../Tabs-styled';
import { DropdownLUXE } from '../../UIHelpersLUXE/Dropdown/DropdownLUXE';
import { DimensionsTabContainer, WidthThicknessTabRow } from './DimensionsLUXE-styled';


interface Props {
  fingerSize:string,
  fingerSizeOptions:string[],
  onFingerSizeChange:(value:string)=>void,
  fingerSizeFormat:string,
  fingerSizeFormatOptions:string[],
  onFingerSizeFormatChange:(value:string)=>void,
  ringWidth:number,
  ringWidthOptions:number[],
  onRingWidthChange:(value:number)=>void,
  ringThickness:number,
  ringThicknessOptions:number[],
  onRingThicknessChange:(value:number)=>void,
  checkoutIssues:('fingerSize'|'debug')[],
  mobile:boolean,
  menuHeight:number,
  menuScaleFactor:number
}

interface State {

}


export default class Dimensions extends React.Component<Props,State> {
  constructor(props: Props) {
    super(props);
  }

  public render = () => {
    const {
      onFingerSizeChange,
      fingerSizeFormat,
      fingerSizeFormatOptions,
      onFingerSizeFormatChange,
      checkoutIssues,
      mobile,
      menuHeight,
      menuScaleFactor
    } = this.props;

    const fingerSizeOptions = this.props.fingerSizeOptions.map((option) => {
      option = option.replace('1/4', '¼');
      option = option.replace('1/2', '½');
      option = option.replace('3/4', '¾');
      return option;
    });

    const fingerSize = this.props.fingerSize.replace('1/4', '¼').replace('1/2', '½').replace('3/4', '¾');

    const ringWidth = `${this.props.ringWidth}MM`;
    const ringWidthOptions = this.props.ringWidthOptions.map((option) => { return `${option}MM` });
    const onRingWidthChange = (value) => { this.props.onRingWidthChange(Number(value.replace("MM",""))) };

    const ringThickness = `${this.props.ringThickness}MM`;
    const ringThicknessOptions = this.props.ringThicknessOptions.map((option) => { return `${option}MM` });
    const onRingThicknessChange = (value) => { this.props.onRingThicknessChange(Number(value.replace("MM",""))) };
  
    return (
      <DimensionsTabContainer mobile={mobile} menuHeight={menuHeight} menuScaleFactor={menuScaleFactor}>
        <TabHeader>DIMENSIONS</TabHeader>

        <TabRow>
          <TabElementLabel>Ring Sizing System</TabElementLabel>
          <TabElementLabel>Ring Size</TabElementLabel>
        </TabRow>
        <TabRow>
          <DropdownLUXE
            options={fingerSizeFormatOptions.map((el) => {return {value: el, label: el}})}
            defaultOption={{ value: fingerSizeFormat, label: fingerSizeFormat }}
            onChange={onFingerSizeFormatChange}
          />
          <DropdownLUXE
            options={fingerSizeOptions.map((el) => {return {value: el, label: el}})}
            defaultOption={{ value: fingerSize, label: fingerSize }}
            onChange={onFingerSizeChange}
            highlight={checkoutIssues.includes('fingerSize')}
          />
        </TabRow>

        <WidthThicknessTabRow>
          <TabElementLabel>Width</TabElementLabel>
          <TabElementLabel>Thickness</TabElementLabel>
        </WidthThicknessTabRow>
        <TabRow>
          <DropdownLUXE
            options={ringWidthOptions.map((el) => {return {value: el, label: el}})}
            defaultOption={{ value: ringWidth, label: ringWidth }}
            onChange={onRingWidthChange}
          />
          <DropdownLUXE
            options={ringThicknessOptions.map((el) => {return {value: el, label: el}})}
            defaultOption={{ value: ringThickness, label: ringThickness }}
            onChange={onRingThicknessChange}
          />
        </TabRow>
      </DimensionsTabContainer>
    )
  }
}